import { RedirectExceptNativaRoleGuard } from './core/guards/redirect-except-nativa-role.guard';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './core/guards/auth.guard';
import { HasNativaRoleGuard } from './core/guards/has-nativa-role.guard';
import { RedirectIfAuthenticatedGuard } from './core/guards/redirect-if-authenticated.guard';

import { LogoutIfAuthenticatedGuard } from './core/guards/logout-if-authenticated.guard';
import { RedirectWithoutConsents } from './core/guards/must-provide-concents.guard';
import { HasAlreadyProvidedConsents } from './core/guards/has-provided-concents.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    loadComponent: () =>
      import('./dashboard/components/user-dashboard/user-dashboard.component').then((m) => m.UserDashboardComponent),
    canActivate: [AuthGuard, RedirectExceptNativaRoleGuard, RedirectWithoutConsents],
  },
  {
    path: 'signin',
    children: [
      {
        canActivate: [RedirectIfAuthenticatedGuard],
        path: '',
        loadComponent: () => import('./auth/components/signin/signin.component').then((m) => m.SigninComponent),
      },
      {
        canActivate: [LogoutIfAuthenticatedGuard],
        path: 'reset',
        loadComponent: () =>
          import('./auth/components/reset-password/reset-password.component').then((m) => m.ResetPasswordComponent),
      },
      {
        canActivate: [LogoutIfAuthenticatedGuard],
        path: 'activate',
        loadComponent: () =>
          import('./auth/components/activate-account/activate-account.component').then(
            (m) => m.ActivateAccountComponent
          ),
      },
      {
        path: 'check-your-email',
        loadComponent: () =>
          import('./auth/components/check-your-email/check-your-email.component').then(
            (m) => m.CheckYourEmailComponent
          ),
      },
    ],
  },
  {
    path: 'signup',
    canActivate: [RedirectIfAuthenticatedGuard],
    loadComponent: () => import('./auth/components/singup/signup.component').then((m) => m.SignupComponent),
  },
  {
    path: 'signin/reset-request',
    loadComponent: () =>
      import('./auth/components/pwd-reset-request/pwd-reset-request').then((m) => m.PwdResetRequestComponent),
  },
  {
    path: 'connect',
    canActivate: [LogoutIfAuthenticatedGuard],
    loadComponent: () => import('./auth/components/connect/connect.component').then((m) => m.ConnectComponent),
  },
  {
    path: 'not-found',
    loadComponent: () =>
      import('./core/components/page-not-found/page-not-found.component').then((m) => m.PageNotFoundComponent),
  },
  {
    path: 'privacy-policy',
    loadComponent: () => import('./privacy-policy/privacy-policy.component').then((m) => m.PrivacyPolicyComponent),
  },
  {
    path: 'terms-and-conditions',
    loadComponent: () =>
      import('./terms-and-conditions/terms-and-conditions.component').then((m) => m.TermsAndConditionsComponent),
  },
  {
    path: 'error',
    loadComponent: () =>
      import('./core/components/app-error-page/app-error-page.component').then((m) => m.AppErrorPageComponent),
  },
  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      {
        path: 'mgmt',
        canActivate: [AuthGuard, HasNativaRoleGuard,RedirectWithoutConsents],
        loadChildren: () => import('./management/management.module').then((m) => m.ManagementModule),
      },
      {
        path: 'consents',
        canActivate: [HasAlreadyProvidedConsents],
        loadComponent: () => import('./auth/components/consents/consents.component').then((m) => m.ConsentsComponent),
      },
      {
        path: ':tenant',
        canActivate: [RedirectWithoutConsents],
        children: [
          {
            path: 'home',
            loadComponent: () =>
              import('./management/components/tenant/tenant-stats/mgmt-tenant-stats.component').then(
                (m) => m.MgmtTenantStatsComponent
              ),
          },
          {
            path: 'account',
            loadChildren: () => import('./manage-account/manage-account.module').then((m) => m.ManageAccountModule),
          },
          {
            path: 'planning',
            loadChildren: () => import('./actions/actions.module').then((m) => m.ActionsModule),
          },
          {
            path: 'reports',
            loadChildren: () => import('./report/report.module').then((m) => m.ReportModule),
          },
          {
            path: 'actions',
            loadChildren: () => import('./actions/actions.module').then((m) => m.ActionsModule),
          },
          {
            path: '',
            redirectTo: '/not-found',
            pathMatch: 'full',
          },
        ],
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
